import { definePreset } from '@primeuix/themes';
import Aura from '@primeng/themes/aura';

const defaultBorderRadius = '1rem';

const ThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
  components: {
    toolbar: {
      root: {
        padding: '0',
      },
    },
    tabs: {
      tabpanel: {
        padding: '1rem 0',
      },
    },
    listbox: {
      option: {
        borderRadius: defaultBorderRadius,
      },
    },
    button: {
      root: {
        borderRadius: defaultBorderRadius,
        label: {
          fontWeight: defaultBorderRadius,
        },
      },
    },
  },
});

export const LtcThemePreset = ThemePreset;
